import request from '@/utils/request'

const state = {
    editCategory: null
}

const mutations = {
    SET_EDIT_CATEGORY(state, category) {
        state.editCategory = category
    },
    CLEAR_EDIT_CATEGORY(state) {
        state.editCategory = null
    }
}

const actions = {
    fetchCategoryDetail({ commit }, id) {
        return new Promise((resolve, reject) => {
            request.get(`/platform/category/detail`, { params: { id } })
                .then(res => {
                    if (res.success) {
                        commit('SET_EDIT_CATEGORY', res.data)
                        resolve(res.data)
                    } else {
                        reject(new Error(res.message || '获取栏目详情失败'))
                    }
                })
                .catch(err => {
                    reject(err)
                })
        })
    },
    clearEditCategory({ commit }) {
        commit('CLEAR_EDIT_CATEGORY')
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
